import { apiMipe } from '@/core/api/';
const BASE_URL = 'api/signaturehub';

export const searchUserEmail = (params) =>
  apiMipe.get(`api/userprofiles/searchuseremail`, { params });

export const getParticipants = (typeId, relatedId) => {
  return apiMipe.get(`${BASE_URL}/participants/${typeId}/${relatedId}`);
};

export const getSignatureHubInfo = (typeId, relatedId) => {
  return apiMipe.get(`${BASE_URL}/signaturehubinfo/${typeId}/${relatedId}`);
};

export const saveSignatureHub = (payload) => {
  return apiMipe.post(`${BASE_URL}/signaturehub`, payload);
};

export const sendDocument = (typeId, relatedId) => {
  return apiMipe.post(`${BASE_URL}/senddocument/${typeId}/${relatedId}`);
};

export const resendInvitation = (payload) => {
  return apiMipe.post(`${BASE_URL}/resendinvitation`, payload);
};

export const cancelDocument = (typeId, relatedId, payload) => {
  return apiMipe.post(
    `${BASE_URL}/canceldocument/${typeId}/${relatedId}`,
    payload
  );
};

export const getSignedDocument = (typeId, relatedId, documentId) => {
  return apiMipe.get(`${BASE_URL}/signeddocument/${typeId}/${relatedId}`, {
    params: {
      documentId,
    },
  });
};

export const getSignDocumentUrl = (typeId, relatedId) => {
  return apiMipe.get(`${BASE_URL}/signdocumenturl/${typeId}/${relatedId}`);
};

export const removeSignatureHub = (typeId, relatedId) => {
  return apiMipe.delete(`${BASE_URL}/signaturehub/${typeId}/${relatedId}`);
};
